/** @format */

import { Link } from "react-router-dom";
import { Badges, LI } from "../../../AbstractElements";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { openView } from "../../../ReduxToolkit/Reducers/viewReducer";
export default function ChatNav() {
  const { unreadMessageCount } = useSelector((state) => state.chat);
  const dispatch = useDispatch();

  return (
    <LI className="" title="Chats">
      <Link to={"#"} onClick={() => dispatch(openView("chat"))}>
        <i className="fa fa-comments"></i>
        <Badges color="danger" pill style={{ color: "white" }}>
          {`${unreadMessageCount} `}
        </Badges>
      </Link>
    </LI>
  );
}
